import React, { FunctionComponent } from "react";
import styles from "./Spinner.module.scss";
import SpinnerContent from "./Spinner.interface";

import combineClasses from "helpers/combine-classes";

const Spinner: FunctionComponent<SpinnerContent> = (props) => {
    return (
        <div className={combineClasses([styles.wrapper, props.className])}>
            <svg className={styles.spinner} viewBox="0 0 50 50">
                <circle className={styles.path} cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
            </svg>
        </div>
    );
};

export default Spinner;